import { dew as _outsideDew } from "./outside";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  // Determine if version is greater than all the versions possible in the range.
  const outside = _outsideDew();
  const gtr = (version, range, options) => outside(version, range, ">", options);
  exports = gtr;
  return exports;
}